module.exports = __webpack_public_path__ + "img/arrowr.172ac3b6.svg";